import { render } from "./AppTemplatePreviewCard.vue?vue&type=template&id=1abb71f2"
import script from "./AppTemplatePreviewCard.vue?vue&type=script&lang=js"
export * from "./AppTemplatePreviewCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__